// App.tsx
import React from 'react';
import { LanguageProvider } from './context/LanguageContext';
import { ClipShareProvider } from './context/ClipShareContext';
import { MainLayout } from './components/MainLayout';
import { AlertProvider } from './context/AlertContext';
import './styles/globals.css';

const App: React.FC = () => {
  return (
    <LanguageProvider>
      <AlertProvider>
        <ClipShareProvider>
          <MainLayout />
        </ClipShareProvider>
      </AlertProvider>
    </LanguageProvider>
  );
};

export default App;